import React, { useState, useEffect } from 'react';
import confetti from 'canvas-confetti';

// Base URL del worker de autenticación
const AUTH_API_BASE = 'https://auth.tareia.com';

const Gracias = () => {
  const [step, setStep] = useState('form'); // 'form', 'loading', 'final'
  const [selectedLevels, setSelectedLevels] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [statusType, setStatusType] = useState('new'); // 'new' or 'exists'
  const [hasAccess, setHasAccess] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const [isValidatingAccess, setIsValidatingAccess] = useState(true);

  useEffect(() => {
    window.scrollTo(0, 0);
    
    // Mostrar información de debug
    const workerSuccess = localStorage.getItem('debug_worker_success');
    const workerError = localStorage.getItem('debug_worker_error');
    const generalError = localStorage.getItem('debug_general_error');
    
    if (workerSuccess) {
      console.log('🔍 DEBUG: Worker funcionó correctamente');
      localStorage.removeItem('debug_worker_success');
    }
    if (workerError) {
      console.log('🔍 DEBUG: Error del Worker:', workerError);
      localStorage.removeItem('debug_worker_error');
    }
    if (generalError) {
      console.log('🔍 DEBUG: Error general:', generalError);
      localStorage.removeItem('debug_general_error');
    }
    
    // VALIDACIÓN REAL CON WORKER - NO SE PUEDE BURLAR
    const validateAccess = async () => {
      console.log('🔍 Validando acceso REAL con Worker...');
      
      try {
        // Validar acceso usando el endpoint correcto /gracias
        const response = await fetch(`${AUTH_API_BASE}/gracias`, {
          method: 'HEAD',
          credentials: 'include'
        });

        console.log('📡 Respuesta validación:', response.status, response.statusText);

        if (response.ok) {
          // Cookie válida del servidor
          console.log('✅ Acceso válido del servidor');
          setHasAccess(true);
        } else {
          // Sin cookie válida del servidor
          console.log('❌ Sin acceso válido del servidor, redirigiendo');
          window.location.replace('/');
          return;
        }
      } catch (error) {
        console.error('❌ Error validando con servidor:', error);
        window.location.replace('/');
        return;
      } finally {
        setIsValidatingAccess(false);
      }
      
      // Obtener status del query parameter
      const urlParams = new URLSearchParams(window.location.search);
      const status = urlParams.get('status');
      console.log('📋 Status del query:', status);
      
      if (status === 'exists') {
        setStatusType('exists');
        setStep('final');
      } else {
        setStatusType('new');
      }
    };

    validateAccess();
  }, []);

  useEffect(() => {
    if (step === 'final') {
      window.scrollTo(0, 0);
    }
  }, [step]);

  // Confetti animation on page load
  useEffect(() => {
    const timer = setTimeout(() => {
      confetti({
        particleCount: 100,
        spread: 70,
        origin: { y: 0.6 },
        colors: ['#3B82F6', '#8B5CF6', '#10B981', '#F59E0B']
      });
    }, 300);

    return () => clearTimeout(timer);
  }, []);

  const handleDownloadPDF = async () => {
    setIsDownloading(true);
    
    try {
      // Descargar desde Worker protegido - SEGURIDAD REAL
      const response = await fetch(`${AUTH_API_BASE}/api/descargar`, {
        method: 'GET',
        credentials: 'include'
      });

      if (response.ok) {
        const blob = await response.blob();
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement('a');
        a.href = url;
        a.download = 'Tareia - Material Educativo De Muestra.pdf';
        document.body.appendChild(a);
        a.click();
        window.URL.revokeObjectURL(url);
        document.body.removeChild(a);
        console.log('✅ Descarga protegida exitosa');
      } else {
        console.error('❌ Descarga no autorizada');
        alert('Error al descargar el archivo. Por favor, inténtalo de nuevo.');
      }
    } catch (error) {
      console.error('❌ Error en descarga:', error);
      alert('Error al descargar el archivo. Por favor, inténtalo de nuevo.');
    } finally {
      setIsDownloading(false);
    }
  };

  const levels = [
    { id: 'Preescolar', label: 'Preescolar' },
    { id: 'Primaria', label: 'Primaria' },
    { id: 'Secundaria', label: 'Secundaria' }
  ];

  const subjects = [
    { id: 'Matemáticas', label: 'Matemáticas' },
    { id: 'Español', label: 'Español' },
    { id: 'Ciencias', label: 'Ciencias' },
    { id: 'Inglés', label: 'Inglés' },
    { id: 'Otra', label: 'Otra' }
  ];

  const toggleLevel = (levelId) => {
    setSelectedLevels(prev => 
      prev.includes(levelId) 
        ? prev.filter(id => id !== levelId)
        : [...prev, levelId]
    );
  };

  const toggleSubject = (subjectId) => {
    setSelectedSubjects(prev => 
      prev.includes(subjectId) 
        ? prev.filter(id => id !== subjectId)
        : [...prev, subjectId]
    );
  };

  const handleContinue = async () => {
    if (selectedLevels.length === 0) return;
    
    setIsLoading(true);
    
    try {
      const email = localStorage.getItem('email');
      
      const response = await fetch('https://tareia-contact-update-api.joseeloyvelazquezojeda.workers.dev', {
        method: 'POST',
        headers: { 
          'Content-Type': 'application/json',
          'Origin': 'https://tareia.com'
        },
        body: JSON.stringify({
          email,
          niveles: selectedLevels.join(', '),
          materias: selectedSubjects.join(', ')
        })
      });

      if (response.ok) {
        const data = await response.json();
        console.log('✅ Contacto actualizado correctamente:', data.status);
      } else {
        console.warn('⚠️ Error al actualizar contacto: respuesta no exitosa');
      }
    } catch (error) {
      console.warn('⚠️ Error al actualizar contacto (continuando):', error.message);
    } finally {
      setIsLoading(false);
      setStep('final'); // Siempre continuar al paso final
    }
  };

  const handleSkip = () => {
    setStep('final');
  };

  const handleBackToHome = () => {
    window.location.href = '/';
  };

  // Mostrar loading mientras valida acceso
  if (isValidatingAccess) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4 py-8">
        <div className="text-center">
          <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-2xl flex items-center justify-center mx-auto mb-6 my-8">
            <div className="w-8 h-8 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
          </div>
          <p className="text-gray-600">Verificando acceso...</p>
        </div>
      </div>
    );
  }

  // Si no tiene acceso, no mostrar nada (ya se redirigió)
  if (!hasAccess) {
    return null;
  }

  if (step === 'final') {
    return (
      <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4 py-8">
        <div className="max-w-2xl mx-auto text-center animate-fade-in">
          <div className="bg-white rounded-3xl shadow-2xl p-12 my-8">
            <div className="w-20 h-20 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-full flex items-center justify-center mx-auto mb-8">
              <span className="text-3xl">{statusType === 'exists' ? '✉️' : '🎉'}</span>
            </div>
            
            <h1 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6">
              {statusType === 'exists' ? 'Este correo ya está registrado' : '¡Listo!'}
            </h1>
            
            <p className="text-xl text-gray-600 mb-8 leading-relaxed">
              {statusType === 'exists' ? (
                <>
                  Ya estás en la lista de acceso anticipado de <span className="text-primary-600 font-bold">Tareia</span>.<br />
                  Te avisaremos cuando Tareia esté disponible.
                </>
              ) : (
                <>
                  Te avisaremos en cuanto <span className="text-primary-600 font-bold">Tareia</span> esté disponible.<br />
                  Mientras tanto, revisa tu correo 👀
                </>
              )}
            </p>

            {statusType === 'new' && (
              <div className="bg-gray-50 rounded-2xl p-6 mb-8">
                <p className="text-gray-700 font-medium mb-2">Comparte Tareia con otros docentes 👇</p>
                <p className="text-primary-600 font-bold text-lg">tareia.com</p>
              </div>
            )}
            
            <button
              onClick={handleBackToHome}
              className="bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white font-bold py-4 px-8 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-lg"
            >
              Volver al inicio
            </button>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary-50 to-secondary-50 flex items-center justify-center px-4 py-8">
      <div className="max-w-2xl mx-auto animate-fade-in">
        <div className="bg-white rounded-3xl shadow-2xl p-8 md:p-12 my-8">
          {/* Header */}
          <div className="text-center mb-8">
            <div className="w-16 h-16 bg-gradient-to-br from-primary-600 to-secondary-600 rounded-2xl flex items-center justify-center mx-auto mb-6">
              <span className="text-2xl">🎉</span>
            </div>
            
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              ¡Ya estás dentro de <span className="text-primary-600 font-extrabold">Tareia</span>!
            </h1>
            
            <p className="text-lg text-gray-600 leading-relaxed mb-8">
              Te avisaremos en cuanto esté listo. Mientras tanto, descarga las actividades de muestra 👇
            </p>

            {/* Botón de descarga PRIMERO */}
            <div className="mb-8">
              <button
                onClick={handleDownloadPDF}
                disabled={isDownloading}
                className={`bg-gradient-to-r from-green-600 to-green-700 hover:from-green-700 hover:to-green-800 text-white font-bold py-4 px-8 rounded-xl transition-all duration-200 shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 text-lg mb-4 ${
                  isDownloading ? 'opacity-50 cursor-not-allowed' : ''
                }`}
              >
                {isDownloading ? (
                  <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Descargando...
                  </div>
                ) : (
                  <>📄 Descargar actividades de muestra</>
                )}
              </button>
              <p className="text-sm text-gray-500">
                Descarga 8 actividades listas para usar en tu aula
              </p>
            </div>

            <p className="text-lg text-gray-600 leading-relaxed">
              Ayúdanos a conocerte mejor (opcional) 👇
            </p>
          </div>

          {/* Form */}
          <div className="space-y-8">
            {/* Levels Section */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-1">
                ¿En qué niveles enseñas?
              </h3>
              <p className="text-sm text-gray-500 mb-4">Esto nos ayuda a darte una mejor experiencia cuando lancemos</p>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                {levels.map((level) => (
                  <button
                    key={level.id}
                    onClick={() => toggleLevel(level.id)}
                    className={`p-4 rounded-xl border-2 transition-all duration-200 font-medium ${
                      selectedLevels.includes(level.id)
                        ? 'border-primary-500 bg-primary-50 text-primary-700'
                        : 'border-gray-200 hover:border-gray-300 text-gray-700'
                    }`}
                  >
                    {level.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Subjects Section */}
            <div>
              <h3 className="text-xl font-bold text-gray-900 mb-4">
                Materias principales (opcional)
              </h3>
              <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
                {subjects.map((subject) => (
                  <button
                    key={subject.id}
                    onClick={() => toggleSubject(subject.id)}
                    className={`p-4 rounded-xl border-2 transition-all duration-200 font-medium ${
                      selectedSubjects.includes(subject.id)
                        ? 'border-secondary-500 bg-secondary-50 text-secondary-700'
                        : 'border-gray-200 hover:border-gray-300 text-gray-700'
                    }`}
                  >
                    {subject.label}
                  </button>
                ))}
              </div>
            </div>

            {/* Actions */}
            <div className="pt-6 space-y-4">
              <button
                onClick={handleContinue}
                disabled={selectedLevels.length === 0 || isLoading}
                className={`w-full font-bold py-4 px-6 rounded-xl transition-all duration-200 text-lg ${
                  selectedLevels.length === 0 || isLoading
                    ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
                    : 'bg-gradient-to-r from-primary-600 to-secondary-600 hover:from-primary-700 hover:to-secondary-700 text-white shadow-lg hover:shadow-xl transform hover:-translate-y-0.5'
                }`}
              >
                {isLoading ? (
                  <div className="flex items-center justify-center">
                    <div className="w-5 h-5 border-2 border-white border-t-transparent rounded-full animate-spin mr-2"></div>
                    Guardando...
                  </div>
                ) : (
                  'Continuar'
                )}
              </button>
              
              <button
                onClick={handleSkip}
                disabled={isLoading}
                className="w-full text-gray-500 hover:text-gray-700 transition-colors text-sm underline"
              >
                Omitir
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gracias;